import { render } from "./UnkownError.vue?vue&type=template&id=628021d2"
import script from "./UnkownError.vue?vue&type=script&lang=js"
export * from "./UnkownError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__